import { type UseQueryResult, useQuery } from 'react-query';
import {
  UserDefinedFieldsService,
  UserDefinedFieldsSharedService,
} from '../../services/wealthlane-customer-services';

const useGetUdfModules = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const udfModules = useQuery(
    ['getUdfModules'],
    async () => {
      return await handleRequest(
        UserDefinedFieldsSharedService.getApiCustomerApiAppUserDefinedFieldsUserDefinedModules()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return udfModules;
};

export default useGetUdfModules;
